"use client";
import NFLink from "app/components/NFLink/NFLink";
import UserCircleIcon from "@heroicons/react/24/outline/UserCircleIcon";
import StarIcon from "@heroicons/react/16/solid/StarIcon";
import StarIconOutline from "@heroicons/react/24/outline/StarIcon";
import React, {useState} from "react";
import RatingBar from "../RatingBar/RatingBar";
import {usePhrase} from "../../i18n";
import apiFetcher from "provider/magento/apiFetcher";
import {getPaginatedReviews} from "provider/magento/api/reviews";
import useSWRImmutable from "swr/immutable";
import {normalizePaginatedReviews} from "provider/magento/normalizers/reviews";
import Button from "../Button/Button";
import {sendGTMEvent} from "@next/third-parties/google";

const ProductReviews = ({storeCode, product, storeLocale, _t}) => {


    const t = usePhrase(_t);
    //const t = await getTranslator(storeCode);

    const {data: reviews} = useSWRImmutable(getPaginatedReviews(product.id, storeCode), ([url,options]) => apiFetcher(url,options).then(res => normalizePaginatedReviews(res)));
    //const reviews = await apiFetcher(...getPaginatedReviews(product.id, storeCode)).then(res => normalizePaginatedReviews(res));

    const [showReviewNumber, setShowReviewNumber] = useState(5);
    //const showReviewNumber = 5;

    const handleMoreReviews = () => {
        setShowReviewNumber(showReviewNumber + 5);
        sendGTMEvent({
            event: 'view_more_reviews',
            product: product?.sku,
            storeView: storeCode
        });
    };


    //const reviews = await apiFetcher(...getPaginatedReviews(product.ekomi_product_id, storeCode)).then(res => normalizePaginatedReviews(res));


    return <div id={'reviews'} className={'lg:container px-2 mx-auto'}>

        <hr className={`spacer my-3`}/>
        <div className={''}>
            <h3 className={'font-bold text-2xl py-3'}>{t('Customers reviews')}</h3>
        </div>
        <div className={'flex flex-col lg:flex-row'}>

            <div className={'rounded  w-full lg:w-auto min-w-[20rem]'}>

                <div className={`relative md:sticky lg:top-48 lg:py-2 `}>
                    <div className={'flex flex-col'}>

                        <div className={'flex flex-col  mb-2'}>

                            <div className={`flex items-center space-x-1`}>
                                <div className={'flex space-x-0.5'}>
                                    {[...Array(Math.floor(product.reviews_average))].map((n, i) => <StarIcon
                                        key={'main_sub_review_star_col_' + i} className={'h-7 w-7 text-[#e7bb43]'}/>)}
                                    {[...Array(5 - Math.floor(product.reviews_average))].map((n, i) => <StarIconOutline
                                        key={'main_sub_review_star_uncol_' + i} className={'h-7 w-7 text-[#e7bb43]'}/>)}
                                </div>
                                <span className={'text-xl '}>{product.reviews_average || '0'} {t('on')} 5</span>
                            </div>
                            <span
                                className={'underline text-sm mt-2'}>{product.reviews_count || '0'} {t('reviews')}</span>
                        </div>

                        <div className={'flex flex-col '}>
                            {reviews?.items && [5, 4, 3, 2, 1].map((n, i) => <RatingBar key={'rating_bar_' + n}
                                                                                        index={i} reviews={reviews}
                                                                                        starsNumber={n}/>)}
                        </div>

                    </div>

                    <div className={'border-t border-t-[#D8D8D9] mt-4'}>

                        <div className={'text-xs pt-4 pb-0'}>
                            <p>{t('Reviews are managed by:')}</p>
                            <p>
                                <NFLink storeCode={storeCode} href={'https://ekomi.com'} className={'underline'}>
                                    eKomi.com
                                </NFLink>
                            </p>
                        </div>

                    </div>

                </div>

            </div>


            <div className={`mt-3 lg:mt-0 grow`}>
                {reviews?.items && reviews.items.slice(0, showReviewNumber).map((review, i) =>
                    <div key={'review_box_' + i} className={'bg-white rounded mb-3 lg:px-8 px-0 lg:mb-5 '}>
                        <div className={'mb-0.5 flex items-center space-x-1'}>
                        <span>
                            <UserCircleIcon className={'w-6 h-6 stroke-1'}/>
                        </span>
                            <span className={'font-bold'}>{review.screenname}</span>
                        </div>
                        <div className={'text-sm flex space-x-2'}>
                            <div className={'flex'}>
                                {[...Array(parseInt(review.rating))].map((n, index) => <StarIcon
                                    key={'review_' + i + '_star_col_' + index} className={'h-5 w-5 text-[#e7bb43]'}/>)}
                                {[...Array(5 - parseInt(review.rating))].map((n, index) => <StarIconOutline
                                    key={'review_' + i + '_star_uncol_' + index}
                                    className={'h-5 w-5 text-[#e7bb43]'}/>)}
                            </div>
                            <div><span className={'font-bold'}>{review.rating}</span></div>
                        </div>
                        <div className={'mb-1 text-sm flex'}>
                            <div>{t('Review left on the day')}</div>
                            <div className={'font-bold ml-1'}>{new Date(review.submitted).toLocaleString(storeLocale, {
                                day: "numeric",
                                month: "long",
                                year: "numeric"
                            })}</div>
                        </div>
                        <div>
                            <p className={'text-base text-justify'}>
                                {review.review}
                            </p>
                        </div>
                    </div>)}

                <div className={`flex justify-center items-center my-3 lg:px-8 px-0`}>
                    <Button white className={`!block !w-auto`} onClick={handleMoreReviews}>{t('More reviews')}</Button>
                </div>
            </div>

        </div>
    </div>;

};

export default ProductReviews;